import React, { useCallback, useMemo } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import NuevoTurno, { NuevoTurnoInicial } from '../components/turnos/NuevoTurno';
import AppointmentForm from '../components/AppointmentForm';

/**
 * /appointments-enhanced/new — alta de turno en una pantalla.
 * Parámetros: clientId, vehicleId, budgetId (desde Presupuestos), date + slot
 * (desde el calendario), immediate=1 / walkin=1 (entra ahora).
 * Con clasico=1 se usa el formulario anterior de dos pasos (red de seguridad).
 */
const AppointmentCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clasico = searchParams.get('clasico') === '1';
  const initial = useMemo<NuevoTurnoInicial>(() => ({
    clientId: searchParams.get('clientId') || undefined,
    vehicleId: searchParams.get('vehicleId') || undefined,
    budgetId: searchParams.get('budgetId') || undefined,
    date: searchParams.get('date') || undefined,
    slot: searchParams.get('slot') || undefined,
    immediate: searchParams.get('immediate') === '1' || searchParams.get('walkin') === '1'
  }), [searchParams]);

  const handleDone = useCallback(() => navigate('/appointments-enhanced'), [navigate]);

  const paramsClasico = new URLSearchParams(searchParams);
  paramsClasico.set('clasico', '1');

  if (clasico) {
    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">
            {initial.immediate ? 'Walk-in (Recepción inmediata)' : 'Nuevo turno'}
          </h1>
        </div>
        <AppointmentForm
          asPage
          isOpen
          mode="create"
          initialData={{ scheduledDate: initial.date, timeSlot: initial.slot, clientId: initial.clientId, vehicleId: initial.vehicleId, budgetId: initial.budgetId }}
          defaultImmediate={initial.immediate}
          onClose={handleDone}
          onSuccess={handleDone}
        />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">Nuevo turno</h1>
        <div className="flex items-center gap-3 text-sm text-muted-foreground">
          {initial.immediate && <span>Walk-in: el vehículo entra ahora</span>}
          {initial.budgetId && <span>Desde un presupuesto aprobado</span>}
          <Link to={`/appointments-enhanced/new?${paramsClasico.toString()}`} className="text-xs underline underline-offset-2 hover:text-foreground">
            Formulario anterior
          </Link>
        </div>
      </div>
      <NuevoTurno initial={initial} />
    </div>
  );
};

export default AppointmentCreatePage;
